import React from 'react'
import Helmet from 'react-helmet'
import R from 'ramda'
import Link from 'gatsby-link'
import classNames from 'classnames'

import Title from 'components/Title'
import Options from 'components/Options'
import Form from 'components/Form'
    
import { 
  postsEnhancer 
} from 'utils/enhancers'

const Box = ({ children, className }) => (
  <div 
    className={classNames({
      'sm-col-6 border-box': true,
      [className]: className
    })}
  >
    {children}
  </div>
)

const BlogPostTemplate = ({ 
  post, 
  siteTitle,
  frontmatter,
  html,
  image,
  intro
}) => (
  <div className='max-width-4 mx-auto px2 mb3'>
    
    <Helmet title={`${frontmatter.title} | ${siteTitle}`} />
    
    <div className='sm-flex flex-wrap'>
      <Title className='sm-col-12'>
        {frontmatter.title}
      </Title>
      
      <Box className='sm-pr2'>

        {image && (
          <div 
            style={{
              backgroundImage: `url(${image})`
            }} 
            className='fit block lesson-image bg-cover bg-center'
          />
        )}
        
        <div 
          dangerouslySetInnerHTML={{ __html: html }} 
          className='mb3'
        />
      </Box>
      
      <Box className='sm-pl2'>
        <h1 className='h4 caps mt0 mb2'>
          Lesson Prices
        </h1>
        <Options className='mb3' />
        
        <h1 className='h4 caps my0'>
          Book a lesson
        </h1>
        <p className='italic gray rounded h4'>
          Use the form below or call Xavier on <a href="tel:00330609524793" className='text-decoration-none'>+33(0)609524793</a>
        </p>
        <Form 
          className='mb3' 
          intro={frontmatter.intro}
        />
      </Box>
      
    </div>

  </div>
)

export default postsEnhancer(BlogPostTemplate)

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        date
        summary
        intro
        image {
          childImageSharp {
            responsiveSizes(maxWidth: 2500, quality: 70) {
              src
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/lesson.js